<template>
	<div :class="classList" v-tooltip="{content: tooltip, html: false}">
		<div class="tag-content">
			<span class="tag-text"><slot></slot></span>
			<span class="addon"><slot is="span" name="addon"></slot></span>
		</div>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
		type: { default: "regular" }, // regular, success, danger, warning
		size: { default: "normal" },
		display: { default: "background" }, // background, underline
		tooltip: { default: null },
	},

	computed: {
		classList() {
			let classList = "tag";

			classList += " " + this.type;
			classList += " " + this.display;
			classList += " size-" + this.size;

			return classList;
		},
	},
};
</script>

<style lang="scss" scoped>
.tag.size-xs .tag-text {
  padding: 0 4px;
  font-size: 12px;
}
</style>